
const digest = 'c1fd88c623760ad02caea2be3ad4a1e4ae2f48305d6bfee3b6b358e07573253f';
const classes = {"wrapper":"_wrapper_17bzh_1","patient":"_patient_17bzh_9","patientImage":"_patientImage_17bzh_15","patientData":"_patientData_17bzh_20","title":"_title_17bzh_20","text":"_text_17bzh_26","content":"_content_17bzh_30","detailTitle":"_detailTitle_17bzh_39","medicament":"_medicament_17bzh_44","date":"_date_17bzh_58","prescriptBy":"_prescriptBy_17bzh_61","prescriptByItem":"_prescriptByItem_17bzh_67","name":"_name_17bzh_73","dose":"_dose_17bzh_76","controls":"_controls_17bzh_81","link":"_link_17bzh_92"};
const css = `._wrapper_17bzh_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_17bzh_1 ._patient_17bzh_9 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 16px;
}
._wrapper_17bzh_1 ._patient_17bzh_9 ._patientImage_17bzh_15 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._wrapper_17bzh_1 ._patient_17bzh_9 ._patientData_17bzh_20 ._title_17bzh_20 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #000000;
}
._wrapper_17bzh_1 ._patient_17bzh_9 ._patientData_17bzh_20 ._text_17bzh_26 {
  color: #9ea0a5;
  font-size: 14px;
}
._wrapper_17bzh_1 ._content_17bzh_30 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._detailTitle_17bzh_39 {
  font-size: 14px;
  font-weight: 500;
  color: #1d65d8;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._medicament_17bzh_44 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._medicament_17bzh_44 ._title_17bzh_20 {
  font-weight: 500;
  min-width: 255px;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._medicament_17bzh_44 ._title_17bzh_20 span {
  font-weight: 400;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._medicament_17bzh_44 ._date_17bzh_58 {
  font-size: 14px;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._prescriptBy_17bzh_61 {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._prescriptBy_17bzh_61 ._prescriptByItem_17bzh_67 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._prescriptBy_17bzh_61 ._prescriptByItem_17bzh_67 ._name_17bzh_73 {
  color: #8b8b8b;
}
._wrapper_17bzh_1 ._content_17bzh_30 ._dose_17bzh_76 {
  display: flex;
  justify-content: center;
  min-width: 50px;
}
._wrapper_17bzh_1 ._controls_17bzh_81 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}
._wrapper_17bzh_1 ._controls_17bzh_81 ._link_17bzh_92 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  